import { lazy } from 'react'
import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'

const Inner = lazy(() => import('./Inner'))

/**
 * Hosts the offer and invitation dialogs that may be shown from anywhere in the
 * app.
 */
export const OpportunityOffersHost = observer(function OpportunityOffersHost() {
  const { isOpportunitiesRequested } = useFeatures((r) => ({
    isOpportunitiesRequested: r.opportunities.internal.isRequested,
  }))

  // Rendering the dialogs loads the feature, so wait until something else has.
  if (!isOpportunitiesRequested()) {
    return null
  }

  return <Inner />
})
